import { extendZodWithOpenApi } from '@anatine/zod-openapi'
import { z } from 'zod'

extendZodWithOpenApi(z)

export const OrderMessageBodyNameEnum = z.enum([
  'order_updated',
  'order_paid',
  'order_created',
  'order_cancelled',
  'address_updated',
  'order_lineitem_updated',
  'order_bundlelineitem_updated',
  'fulfilment_status_updated',
  'order_rebalance_requested',
  'post_payment_order_modified',
])
export type OrderMessageBodyNameEnum = z.infer<typeof OrderMessageBodyNameEnum>

export const OrderRebalancedPayload = z.object({
  toDate: z.string().datetime(),
  timezone: z.string(),
})
export type OrderRebalancedPayload = z.infer<typeof OrderRebalancedPayload>
